var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[_c('h3',[_vm._v("心理弹性干预")]),_vm._v(" "),_c('div',[(_vm.listOrCon)?_c('List',{attrs:{"listArr":_vm.listArr}}):_vm._e(),_vm._v(" "),(!_vm.listOrCon)?_c('router-view'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a81e320","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/psychological.vue
// module id = null
// module chunks = 